import { Box, Modal } from "@mantine/core";
import { useCopyToClipboard } from "usehooks-ts";
import { useGetProjectMemberQuery } from "../../../openapi";
import { Avatar, FailedAlert, MCLoader } from "../../components";
import { setMemberIdModalInRedux } from "../../global/globalSlice";
import { useAppDispatch } from "../../hooks";
import { STANDARD_COLORS } from "../globalConstants";

const MemberModal: React.FC<{ memberId: string; projectId: string }> = ({ memberId, projectId }) => {
  const dispatch = useAppDispatch();

  const [, copy] = useCopyToClipboard();

  const {
    data: member,
    isLoading,
    isError,
  } = useGetProjectMemberQuery({
    projectId: projectId,
    memberId: memberId,
  });

  const roleColors = {
    ADMIN: STANDARD_COLORS.orange,
    PARTNER: STANDARD_COLORS.green,
    INTERNAL: STANDARD_COLORS.grey,
    CLIENT: STANDARD_COLORS.blue,
  };

  const infoRows = [
    { label: "tlf", value: member?.user?.phoneNumber ?? "-" },
    { label: "epost", value: member?.user?.email ?? "-" },
    { label: "disiplin", value: member?.disciplin ?? "-" },
    { label: "domene", value: member?.user?.domain ?? "-" },
    { label: "Lokasjon", value: member?.user?.location ?? "-" },
  ];

  return (
    <Modal
      opened
      onClose={() => dispatch(setMemberIdModalInRedux(null))}
      title={"Prosjektmedlem"}
      size="550px"
      yOffset={140}
    >
      {isError && <FailedAlert />}
      {isLoading && <MCLoader />}
      {member != null && (
        <>
          <div className="memberCard">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ marginRight: "-.5em" }}>
                <Avatar id={member.user._id} name={member.user.name} size="xl" />
              </div>
              <Box component="h3" my="0.25rem">
                {member.user.name}
              </Box>{" "}
              <div
                className="memberGroupBadge"
                style={{ color: `${roleColors[member?.group]}`, border: `3px solid ${roleColors[member?.group]}` }}
              >
                {member?.group}
              </div>
            </div>
            <div className="infoContainer">
              {infoRows.map((row, i) => (
                <div
                  key={i}
                  className="rowContainer"
                  style={{ display: "flex", fontSize: "1.1em", alignItems: "center" }}
                >
                  <div className="rowLabel">{row.label}:</div>
                  <div className="rowValue">{row.value}</div>
                  {row.value && (
                    <button className="addIcon" onClick={() => copy(row.value)}>
                      <i className="fa fa-files-o"></i>
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default MemberModal;
